import MitraService from '@/services/mitra'

export default {
	save({commit}, body) {
		return new Promise((resolve, reject) => {
			MitraService.save(body, {
				headers: {
					'Authorization': localStorage.token
				}
			})
			.then(response => {
				resolve(response.data)
			})
			.catch(e => reject(e))
		})
	},
	getData({commit}, params = {}) {
		return new Promise((resolve, reject) => {
			MitraService.getChoiceMitra({
				params,
				headers: {
					'Authorization': localStorage.token
				}
			})
			.then(response => {
				const mitra = response.data.data
				mitra.map(item => {
					if(item.user && item.user.file !== null) {
						item.user.file = process.env.VUE_APP_STORAGE + '/' + item.user.file
					}
				})
				resolve(mitra)
			})
			.catch(e => reject(e))
		})
	},
	getChoiceMitra({commit}, params = {}) {
		return new Promise((resolve, reject) => {
			MitraService.getChoiceMitra({
				params,
				headers: {
					'Authorization': localStorage.token
				}
			})
			.then(response => {
				const mitra = response.data.data
				mitra.map(item => {
					if(item.user && item.user.file !== null) {
						item.user.file = process.env.VUE_APP_STORAGE + '/' + item.user.file
					}
				})
				commit('SET_DATA', { data: mitra, recordsTotal: response.data.recordsTotal })
				resolve({ data: mitra, recordsTotal: response.data.recordsTotal })
			})
			.catch(e => reject(e))
		})
	},
	getSearchMitra({commit, dispatch}, params ={}) {
		return new Promise((resolve, reject) => {
			MitraService.getChoiceMitra({
				params,
				headers: {
					'Authorization': localStorage.token
				}
			})
			.then(response => {
				const mitra = response.data.data
				mitra.map(item => {
					if(item.user && item.user.file !== null) {
						item.user.file = process.env.VUE_APP_STORAGE + '/' + item.user.file
					}
				})
				commit('SET_DATA', { data: mitra, recordsTotal: response.data.recordsTotal })
				resolve({ data: mitra, recordsTotal: response.data.recordsTotal })
			})
			.catch(e => reject(e))
		})
	},
	getUser({}, params = {}) {
		return new Promise((resolve, reject) => {
			MitraService.getUser({
				params,
				headers: {
					'Authorization': localStorage.token
				}
			})
			.then(response => resolve(response.data))
			.catch(e => reject(e))
		})
	}
}